/** Adviserz brand mark per official identity guide.
 *  Palette: #2563EB → #00B8FF gradient.
 *  Wordmark: Inter Bold (700), letter-spacing +4.
 */

const GRADIENT_ID = "adviserz-grad";

function Gradient() {
  return (
    <defs>
      <linearGradient id={GRADIENT_ID} x1="50%" y1="0%" x2="50%" y2="100%">
        <stop offset="0%" stopColor="#2563EB" />
        <stop offset="100%" stopColor="#00B8FF" />
      </linearGradient>
    </defs>
  );
}

/** Icon-only "A" mark — outer A-frame + inner accent droplet, per brand spec. */
export default function LogoMark({ className = "h-6 w-auto" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none" aria-label="Adviserz">
      <Gradient />
      {/* Outer A-frame: triangular peak with bottom V-notch */}
      <path
        d="M50 6 L93 90 L66 90 L50 60 L34 90 L7 90 Z"
        fill={`url(#${GRADIENT_ID})`}
      />
      {/* Inner accent: smaller peak/droplet at lower-mid */}
      <path
        d="M50 50 L60 78 L50 72 L40 78 Z"
        fill={`url(#${GRADIENT_ID})`}
      />
    </svg>
  );
}

/** Horizontal lockup — icon + ADVISERZ wordmark (Inter Bold, +4 tracking). */
export function BrandLogo({ className = "h-7 w-auto" }) {
  return (
    <svg viewBox="0 0 320 80" className={className} fill="none" aria-label="Adviserz">
      <Gradient />
      {/* Icon (scaled to 64x64 within 80px row) */}
      <g transform="translate(8, 8) scale(0.64)">
        <path d="M50 6 L93 90 L66 90 L50 60 L34 90 L7 90 Z" fill={`url(#${GRADIENT_ID})`} />
        <path d="M50 50 L60 78 L50 72 L40 78 Z" fill={`url(#${GRADIENT_ID})`} />
      </g>
      <text x="84" y="52"
        fontFamily="Inter, ui-sans-serif, system-ui, -apple-system, sans-serif"
        fontSize="32"
        fontWeight="700"
        fill="#FFFFFF"
        letterSpacing="4">
        ADVISERZ
      </text>
    </svg>
  );
}

/** Vertical lockup — icon above wordmark; used in centered hero / login screens. */
export function BrandLogoStacked({ className = "h-20 w-auto" }) {
  return (
    <svg viewBox="0 0 240 200" className={className} fill="none" aria-label="Adviserz">
      <Gradient />
      <g transform="translate(70, 0) scale(1.0)">
        <path d="M50 6 L93 90 L66 90 L50 60 L34 90 L7 90 Z" fill={`url(#${GRADIENT_ID})`} />
        <path d="M50 50 L60 78 L50 72 L40 78 Z" fill={`url(#${GRADIENT_ID})`} />
      </g>
      <text x="120" y="155"
        textAnchor="middle"
        fontFamily="Inter, ui-sans-serif, system-ui, -apple-system, sans-serif"
        fontSize="32"
        fontWeight="700"
        fill="#FFFFFF"
        letterSpacing="4">
        ADVISERZ
      </text>
    </svg>
  );
}
